import { useGetAccountQuery } from '@/services/accounts';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { QuoteStatus } from 'types';

import { useGetQuotesQuery } from '../../services/quotes';
import { useGetCurrentDesignQuery } from '../../services/systemDesign';
import { Origin } from '../../types/ProductionValueCheck';
import { ReviewPackageActions } from '../../types/ReviewPackage';

// TODO: Just implement as a hook
export const NeedsAttestmentGuard = ({ children }: { children: any }) => {
  const { id, action } = useParams<{ id: any; action: ReviewPackageActions }>();
  const { data: account } = useGetAccountQuery(id);
  const programType = account?.programType;
  const { data: currentDesignQueryData, isLoading: isCurrentDesignQueryDataLoading } = useGetCurrentDesignQuery(
    { id, programType },
    { skip: !programType },
  );
  const { data: quotes, isLoading: areQuotesLoading } = useGetQuotesQuery(
    { id, programType },
    { skip: !programType },
  );
  const location = useLocation();
  const navigate = useNavigate();

  const needsAttestment = useMemo(() => {
    const hasActiveQuote = quotes?.find((element: any) => element.status === QuoteStatus.active);
    return Boolean(hasActiveQuote && !currentDesignQueryData?.attestment);
  }, [currentDesignQueryData, quotes]);

  const isLoading = areQuotesLoading || isCurrentDesignQueryDataLoading;
  const shouldRedirect = needsAttestment && !isLoading;

  useEffect(() => {
    if (shouldRedirect && location?.state && location?.state?.shouldRedirect !== false) {
      navigate(`/accounts/${id}/production-value-check`, {
        state: {
          from: Origin.INSTALL_PACKAGE,
          action,
        },
        replace: true,
      });
    }
  }, [shouldRedirect, navigate, id, location, action]);

  return children;
};
